export const TelephoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M23.5 18.8987L27.024 21C27.752 21.4347 28.1279 22.28 27.9612 23.112C27.2799 26.524 23.8534 28.7107 20.4974 27.7893C12.5787 25.616 6.3932 19.4493 4.21187 11.5133C3.2892 8.156 5.47334 4.72664 8.88668 4.04397L8.90914 4.03998C9.74247 3.87332 10.592 4.25065 11.0253 4.98265L13.1093 8.50133C13.8507 9.75333 13.4825 11.3653 12.2705 12.1706L10.0559 13.644C11.6186 17.3867 14.6052 20.3853 18.3372 21.9453L19.8239 19.7253C20.6359 18.516 22.2493 18.1533 23.5 18.8987Z"
        fill="black"
      ></path>
    </svg>
  )
}
